/**
 * Simple loading spinner component.
 *
 * Replaces the legacy AngularJS angular-busy and loading indicators.
 */
interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  className?: string;
}

const sizeClasses = {
  sm: 'h-5 w-5',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

export default function LoadingSpinner({
  size = 'md',
  message,
  className = '',
}: Readonly<LoadingSpinnerProps>) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <div
        className={`animate-spin rounded-full border-b-2 border-brew-blue ${sizeClasses[size]}`}
      />
      {message && <p className="text-sm text-gray-400">{message}</p>}
    </div>
  );
}
